import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "embedded",
})<{ embedded?: boolean }>(
  ({ embedded }) =>
    !embedded
      ? {
          width: "94vw",
          height: "92vh",
          minHeight: "92vh",
          maxHeight: "92vh",
          "&.withFooter": {
            height: "86vh",
            minHeight: "86vh",
            maxHeight: "86vh",
          },
        }
      : {
          "& img": {
            height: "50vh",
          },
        },
  ({ theme }) => ({
    padding: "1%",

    background: `${theme.palette.background.default}`,
    overflow: "hidden",
    boxSizing: "border-box",

    justifyContent: "space-between",
  })
);

export const Header = styled(Grid)(({ theme }) => ({
  height: "5%",
  display: "flex",
  justifyContent: "space-between",

  "& a": {
    color: `${theme.palette.primary.main}`,

    "& svg": {
      width: "30px",
      height: "30px",
    },
  },
}));

export const ThumbnailsContainer = styled(Grid)(({ theme }) => ({
  height: "calc(95% - 30px)",
  overflowY: "auto",
  overflowX: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRight: `1.5px solid ${theme.palette.primary.main}`,
  gap: "2%",
  opacity: "1",
  transition: "all 0.2s linear",
  "&.loading": {
    opacity: "0",
  },

  "& canvas": {
    boxSizing: "border-box",
    margin: "0 auto 5% auto",
    transition: "all 0.2s linear",
    cursor: "pointer",
    border: "1.5px solid transparent",

    "&.current": {
      border: `1.5px solid ${theme.palette.primary.main}`,
    },
  },

  "& .thumbnail": {
    boxSizing: "border-box",
    width: "80%",
    cursor: "pointer",
    border: "1.5px solid transparent",
    transition: "all 0.2s linear",
    padding: "1.5px",

    "&.current": {
      border: `1.5px solid ${theme.palette.primary.main}`,
    },
  },
}));

export const MainViewer = styled(Grid)({
  width: "100%",
  height: "calc(95% - 30px)",
  display: "flex",
  overflow: "auto",
  flexDirection: "column",
  opacity: "1",
  transformOrigin: "top",

  "& canvas": {
    margin: "0 auto",
    transitiion: " all 0.5 linear",

    "&.loading": {
      opacity: "0",
    },
  },

  "& div": {
    width: "90%",
    margin: "0 auto",
    transformOrigin: "top",
    // display: "flex",
    // justifyContent : "center",
  },

  "& #imgContainer": {
    width: "100%",
    display: "flex",
    justifyContent: "center",

    "& img": {
      // width :"100%",
      margin: "auto",
      transformOrigin: "top",
    },
  },
});

export const ToolsContainer = styled(Grid)({
  width: "80%",
  height: "30px",
  marginLeft: "auto",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== "color",
})<{ color?: string }>(({ theme, color }) => ({
  color: color ?? theme.palette.primary.main,
  fontSize: "20px",
}));

//The shadowRoot elements require to be styled inline
export const shadow_thumbnail_style = `<style>
        table , th ,td { 
            border: 0.5px #00000021 solid ;
            border-collapse: collapse;
            table-layout : fixed;
            overflow: hidden;
        }
        td { 
            width: fit-content;
            white-space: nowrap;
            height : 18px;
        }
        td:nth-of-type(n+6){
          display : none;
        }
        tr:nth-of-type(n+6){
            display : none;
        }
        table {
            width : 100%;
        }
        </style>`;

export const shadow_sheet_mainview_body_style = `<style>

        div{
          display : flex;
          flex-wrap : wrap;
        }

        table , th ,td { 
            border: 0.5px #00000021 solid ;
            border-collapse: collapse;
            
            overflow: auto;
        }
        td { 
            width: fit-content;
            white-space: nowrap;
            height : 18px;
            min-width: 40px;
        }
        table {
            width:calc(100% - 40px);
            
        }

        </style>`;
